'use client';

import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContentContainer = styled(Box)(({ theme }) => ({
	position: 'relative',
	padding: theme.spacing(6, 0, 12)
}));

const Section = styled(Box)(({ theme }) => ({
	marginBottom: theme.spacing(6)
}));

const Label = styled(Typography)(({ theme }) => ({
	fontWeight: 800,
	fontSize: `${theme.typography.pxToRem(24)} !important`,
	color: theme.palette.text.primary,
	[theme.breakpoints.up('sm')]: {
		fontSize: `${theme.typography.pxToRem(30)} !important`
	},
	[theme.breakpoints.up('md')]: {
		fontSize: `${theme.typography.pxToRem(32)} !important`
	},
	[theme.breakpoints.up('lg')]: {
		fontSize: `${theme.typography.pxToRem(36)} !important`
	}
}));

const Details = styled(Typography)(({ theme }) => ({
	fontSize: theme.typography.pxToRem(18),
	marginTop: theme.spacing(2),
	[theme.breakpoints.up('md')]: {
		fontSize: theme.typography.pxToRem(20)
	}
}));

const Content = () => {
	return (
		<StyledContentContainer>
			<Container maxWidth={false}>
				<Section>
					<Label variant="h3">Privacy Policy for Volenday</Label>
					<Details>
						At Volenday, accessible from https://www.volenday.com/, one of our main priorities is the
						privacy of our visitors. This Privacy Policy document contains types of information that is
						collected and recorded by Volenday and how we use it.
					</Details>
					<Details>
						If you have additional questions or require more information about our Privacy Policy, do not
						hesitate to contact us through email at contact@volenday.com
					</Details>
				</Section>
				<Section>
					<Label variant="h3">Log Files</Label>
					<Details>
						Volenday follows a standard procedure of using log files. These files log visitors when they
						visit websites. All hosting companies do this and a part of hosting services' analytics. The
						information collected by log files include internet protocol (IP) addresses, browser type,
						Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the
						number of clicks. These are not linked to any information that is personally identifiable. The
						purpose of the information is for analyzing trends, administering the site, tracking users'
						movement on the website, and gathering demographic information.
					</Details>
				</Section>
				<Section>
					<Label variant="h3">Cookies and Web Beacons</Label>
					<Details>
						Like any other website, Volenday uses 'cookies'. These cookies are used to store information
						including visitors' preferences, and the pages on the website that the visitor accessed or
						visited. The information is used to optimize the users' experience by customizing our web page
						content based on visitors' browser type and/or other information.
					</Details>
				</Section>
				<Section>
					<Label variant="h3">Privacy Policies</Label>
					<Details>
						Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons
						that are used in their respective advertisements and links that appear on Volenday, which are
						sent directly to users' browser. They automatically receive your IP address when this occurs.
						These technologies are used to measure the effectiveness of their advertising campaigns and/or
						to personalize the advertising content that you see on websites that you visit.
					</Details>
					<Details>
						If you have additional questions or require more information about our Privacy Policy, do not
						Note that Volenday has no access to or control over these cookies that are used by third-party
						advertisers.
					</Details>
				</Section>
				<Section>
					<Label variant="h3">Third Party Privacy Policies</Label>
					<Details>
						Volenday's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising
						you to consult the respective Privacy Policies of these third-party ad servers for more detailed
						information. It may include their practices and instructions about how to opt-out of certain
						options. You may find a complete list of these Privacy Policies and their links here: Privacy
						Policy Links.
					</Details>
					<Details>
						You can choose to disable cookies through your individual browser options. To know more detailed
						information about cookie management with specific web browsers, it can be found at the browsers'
						respective websites. What Are Cookies?
					</Details>
				</Section>
				<Section>
					<Label variant="h3">Children's Information</Label>
					<Details>
						Another part of our priority is adding protection for children while using the internet. We
						encourage parents and guardians to observe, participate in, and/or monitor and guide their
						online activity.
					</Details>
					<Details>
						Volenday does not knowingly collect any Personal Identifiable Information from children under
						the age of 13. If you think that your child provided this kind of information on our website, we
						strongly encourage you to contact us immediately and we will do our best efforts to promptly
						remove such information from our records.
					</Details>
				</Section>
				<Section>
					<Label variant="h3">Online Privacy Policy Only</Label>
					<Details>
						This Privacy Policy applies only to our online activities and is valid for visitors to our
						website with regards to the information that they shared and/or collect in Volenday. This policy
						is not applicable to any information collected offline or via channels other than this website.
					</Details>
				</Section>
				<Section>
					<Label variant="h3">Consent</Label>
					<Details>
						By using our website, you hereby consent to our Privacy Policy and agree to its Terms and
						Conditions.
					</Details>
				</Section>
			</Container>
		</StyledContentContainer>
	);
};

export default Content;
